<template>
  <SV title="About.关于" class="about">
    <LAlert>
      <h3>-Signature.</h3>
      <p>P图机器 / 背向对象 / 模式混淆 / 数据填埋 / 自动失控 / 赞美田牌 / 中奖绝缘</p>
    </LAlert>
    <LAlert>
      <h3>-Contact.</h3>
      <div class="contact">
        <div v-for="(contact, i) in contacts" :key="`_ABOUT-CONTACT${i}`">
          <a :href="contact.link" target="_black">
            <i :class="`iconfont ${contact.icon}`"></i>
          </a>
          <span>{{contact.name.toUpperCase()}}</span>
        </div>
      </div>
    </LAlert>
    <hr />
    <h2>-Skills.技能树</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">技能点</th>
            <th class="text-left">简介</th>
            <th class="text-left">进度</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(s, i) in skills" :key="`_ABOUT-PROJECT${i}`">
            <td>{{ s.skill }}</td>
            <td :class="s.bb.indexOf('CSS') > -1 ? 'awesome-css' : ''">{{ s.bb }}</td>
            <td>{{ s.schedule }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <hr />
    <h2>-Projects.天坑们</h2>
    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr v-for="(proj, i) in projects" :key="`_ABOUT-PROJECT${i}`">
            <td>{{ proj[0] }}</td>
            <td>{{ proj[1] }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <hr />
    <h2>
      -Dalaos.大佬们
      <i class="material-icons">favorite</i>
    </h2>
    <v-row>
      <v-col cols="6" v-for="(d, i) in dalaos" :key="`_ABOUT-PROJECT${i}`">
        <v-card outlined :href="d[1]" target="_black">
          <v-list-item>
            <v-list-item-avatar style="margin-right: 16px;">
              <v-img src="https://anillc.cn/img/avatar.1b1c4c4d.jpg"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{d[0]}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </SV>
</template>

<script>
import LAlert from "./../components/LAlert";
import SV from "./../components/StandardView";

export default {
  name: "about",
  data() {
    return {
      contacts: [
        {
          name: "bilibili",
          link: "https://space.bilibili.com/7343980",
          icon: "icon-bilibili"
        },
        {
          name: "weibo",
          link: "https://weibo.com/kblonay",
          icon: "icon-weibo"
        },
        {
          name: "github",
          link: "https://github.com/Lipraty",
          icon: "icon-github"
        },
        {
          name: "e-mail",
          link: "mailto:i@lonay.me",
          icon: "icon-emailFilled"
        }
      ],
      skills: [
        {
          skill: "C井",
          bb: "赞美田牌.exe",
          schedule: "能写一个不丑的玩意了"
        },
        {
          skill: "前端三件套",
          bb: "CSSを完全に理解，当前专精Vue.js",
          schedule: "我爱前端.ts"
        },
        {
          skill: "PHP",
          bb: "echo '世界上最好的语言';",
          schedule: "先加上error_reporting(0);"
        },

        {
          skill: "Adobe全家桶",
          bb: "前影视行业混子",
          schedule: "行业Top 55%"
        },
        {
          skill: "3DsMAX",
          bb: "呆在影视行业的时候顺便学的",
          schedule: "海星"
        },
        {
          skill: "Unity3D",
          bb: "写渲染器什么的最讨厌了.mp3",
          schedule: "入门"
        },
        {
          skill: "做饭",
          bb: "“今天吃什么呢？还是外卖吧”",
          schedule: "其实还行"
        }
      ],
      projects: [
        ["MAKjust", "全都在咕，就我一个在干活"],
        ["LonayBlog", "没错独立成单独的blog了"],
        ["Nyan@Minecraft Luncher", "这是被暂时放置play的新坑"],
        ["BiliLiveObserver", "单腿人与DD的监屏利器，顺带直播下载功能"]
      ],
      dalaos: [["An's Blog", "https://anillc.cn/"]]
    };
  },
  components: {
    LAlert,
    SV
  }
};
</script>

<style>
.about {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  align-items: flex-start;
}
.about .v-data-table {
  background-color: transparent !important;
  color: #dc9495;
}
.about .v-card {
  background-color: transparent !important;
}
.about .l-alert {
  flex-direction: column;
  margin: 10px 0;
  font-size: 1rem;
  background-color: rgb(47, 125, 161);
}
.about h1 {
  color: #dc9495;
  letter-spacing: 2px;
  line-height: 1.7rem;
}
.about .contact {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 10px 26px;
}
.about .contact > div {
  margin: 15px 5px;
}
.about .contact a {
  text-align: center;
  text-decoration: none;
  color: #439fca;
  margin-right: 6px;
  transition: all ease-in-out 0.24s;
}
.about .contact a:hover {
  color: white;
}
.about .contact a:hover > i {
  background-color: #dc9495;
}
.about .contact a > i {
  font-size: 26px;
  padding: 6px;
  background-color: white;
  border-radius: 50%;
}
.about .proj li {
  display: flex;
  justify-content: space-between;
  margin: 3px 0;
}
.about .dalao a {
  position: relative;
  color: #ad797a;
  text-decoration: none;
  transition: all ease 0.3s;
}
.about .dalao a:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  width: 0;
  transform: translateY(-50%);
  height: 2px;
  background-color: #439fca;
  transition: width 350ms, left 350ms;
}
.about .dalao a:hover:after {
  left: 0;
  width: 100%;
  transition: width 350ms;
}
.awesome-css::after {
  content: "";
}
</style>